import React from 'react'
import { Link } from 'gatsby'
import { useSelector } from 'react-redux'

import trads from '../../intl/trads.json'

import LinkIcon from '../linkIcon'
import hexagonShape from '../../icons/hexagon-card.svg'
import docPicto from '../../icons/doc-picto.svg'
import pressPicto from '../../icons/press-picto.svg'

import transformLink from '../../utils/transformLink'

const DocCard = ({document, isSmall = false , isPressRelease = false, publicationDate = false}) => {
  const lang = useSelector(state => state.lang)

  let title = null
  let newsUrl
  const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' }

  if (isPressRelease) {
    newsUrl = transformLink(document, false, true).url
    title = document.title
    publicationDate = new Date(document.publicationDate).toLocaleDateString(lang, dateOptions)
    document = document.pressRelease
  }

  document = document.fields ? document.fields : document
  const pdf = document.pdf
    ? (document.pdf.fields ? document.pdf.fields : document.pdf)
    : null

  const fileConvertSize = (aSize) => {
    aSize = Math.abs(parseInt(aSize, 10));
    let def = [[1, 'octets'], [1024, 'ko'], [1024*1024, 'Mo'], [1024*1024*1024, 'Go'], [1024*1024*1024*1024, 'To']]

    for(let i=0; i < def.length; i++){
      if (aSize<def[i][0]) 
        return (aSize/def[i-1][0]).toFixed(2)+' '+def[i-1][1]
    }
  }

  const hasPdf = pdf && pdf.file && pdf.file.url;

  return (
    <div className={`card doc-card ${isPressRelease ? 'doc-card--press' : ''} ${ isSmall ? 'is-small' : ''}`}>
      <svg width="125px" height="127px" className={`doc-card__deco ${isPressRelease ? 'doc-card__deco--press icon-purple' : 'icon-night'}`}>
        <use xlinkHref={hexagonShape.url} />
      </svg>

      { isPressRelease
        ? <svg width="89px" height="76px" className="absolute doc-card__picto-press">
            <use xlinkHref={pressPicto.url} />
          </svg>
        : <svg width="57px" height="60px" className="absolute doc-card__picto-doc">
            <use xlinkHref={docPicto.url} />
          </svg>
      }

      { hasPdf && <a href={pdf.file.url} target="_blank" rel="noopener noreferrer" className="doc-card__wrapper">
        <p className={`card__tag ${isPressRelease ? 'card__tag--press' : ''}`}>{document.type ? trads[lang].docTypes[document.type] : trads[lang].newsroom.pressRelease}</p>

        { isPressRelease &&
          <span className="text-label text-purple mb-2 block">{publicationDate}</span>
        }
        <h3 className="card__title">{title ? title : document.title}</h3>
        <p className={`text-label text-${isPressRelease ? 'purple' : 'sienne'} mt-3 mb-9`}>{fileConvertSize(pdf.file.details.size)}</p>
        
        <LinkIcon text={trads[lang].readPdf} isDownload={true} iconColor={isPressRelease ? 'purple' : 'sienne'} icon="download" />
      </a>
      }
      { isPressRelease &&
        <div className="doc-card__bottom">
          <Link className="link-underline" to={newsUrl}>{trads[lang].share.downloadRelease}</Link>
          { document.annexes &&
            <div>
              <Link className="mt-3 link-underline" to={document.annexes.fields ? document.annexes.fields.file.url : document.annexes.file.url}>{trads[lang].share.annexes}</Link>
            </div>
          }
        </div>
      }
    </div>
  )
}

export default DocCard
